'use strict';

// 如果需要兼容IE9 或其他 则将此文件引入到入口文件中

/* IE9 */

// babel ES6
require('babel-polyfill');

// classList
if (!("classList" in document.documentElement)) {
  Object.defineProperty(HTMLElement.prototype, 'classList', {
    get: function get() {
      var self = this;
      function update(fn) {
        return function (value) {
          var classes = self.className.split(/\s+/g),
            index = classes.indexOf(value);
          fn(classes, index, value);
          self.className = classes.join(" ");
        };
      }
      return {
        add: update(function (classes, index, value) {
          if (!~index) classes.push(value);
        }),
        remove: update(function (classes, index) {
          if (~index) classes.splice(index, 1);
        }),
        toggle: update(function (classes, index, value) {
          if (~index) classes.splice(index, 1);else classes.push(value);
        }),
        contains: function contains(value) {
          return !!~self.className.split(/\s+/g).indexOf(value);
        },
        item: function item(i) {
          return self.className.split(/\s+/g)[i] || null;
        }
      };
    }
  });
}